/**
 * 職種を表します。
 */
export enum JobType {
  /**
   * 靴職人
   */
  MeisterShoes = 'mis',
  /**
   * 鞄職人
   */
  MeisterBags = 'mib',
  /**
   * 販売職
   */
  ClientAdvisor = 'sal',
  /**
   * ITエンジニア
   */
  ITEngineer = 'ite',
}
/**
 * JobType型の値を配列で取得します。
 * @returns 
 */
export function getJobTypeValues() {
  const values = [];

  for(const key in JobType) {
    values.push((JobType as any)[key]);
  }
  return values;
}
